import React from "react";
import { Redirect, Route } from "react-router-dom";

const Resident = React.lazy(() => import("../Containers/Resident"));
const ResidentEditTabs = React.lazy(
  () => import("../Containers/Resident/Tabs/ResidentEditTabs"),
);
const PreAssessmentAdd = React.lazy(
  () => import("../Containers/Resident/ResidentPreAssessment/PreAssessmentAdd"),
);
const ResidentSettingsTabs = React.lazy(
  () => import("../Containers/Resident/Tabs/ResidentSettingsTabs"),
);
const ResidentAdd = React.lazy(
  () => import("../Containers/Resident/ResidentAdd"),
);
const ResidentAssessmentsTabs = React.lazy(
  () => import("../Containers/Resident/Tabs/ResidentAssessmentsTabs"),
);
const ResidentCarePlanTabs = React.lazy(
  () => import("../Containers/Resident/Tabs/ResidentCarePlanTabs"),
);
const ResidentComplianceTabs = React.lazy(
  () => import("../Containers/Resident/Tabs/ResidentComplianceTabs"),
);
const ResidentInsightsToolsTabs = React.lazy(
  () => import("../Containers/Resident/Tabs/ResidentInsightsToolsTabs"),
);
const ResidentLocationRulesTabs = React.lazy(
  () => import("../Containers/Resident/Tabs/ResidentLocationRulesTabs"),
);
const ResidentPreAssessment = React.lazy(
  () => import("../Containers/Resident/ResidentPreAssessment"),
);
const ResidentCarePlanTeam = React.lazy(
  () => import("../Containers/Resident/ResidentSettings/CarePlanTeam"),
);
const ResidentGroups = React.lazy(
  () => import("../Containers/Resident/ResidentSettings/ResidentGroups"),
);
const ResidentCareRoundTypes = React.lazy(
  () => import("../Containers/Resident/ResidentSettings/CareRoundTypes"),
);
const ResidentCareRounds = React.lazy(
  () => import("../Containers/Resident/ResidentSettings/CareRounds"),
);
const CareRoundsPage = React.lazy(
  () =>
    import("../Containers/Resident/ResidentSettings/CareRounds/CareRoundsPage"),
);
const CareRoundsCalendarPage = React.lazy(
  () =>
    import(
      "../Containers/Resident/ResidentSettings/CareRounds/CareRoundsCalendarPage"
    ),
);
const CareRoundsReportPage = React.lazy(
  () =>
    import(
      "../Containers/Resident/ResidentSettings/CareRounds/CareRoundsReportPage"
    ),
);
const ResidentCareRoundEdit = React.lazy(
  () =>
    import("../Containers/Resident/ResidentSettings/CareRounds/CareRoundEdit"),
);
const ResidentCareRoundReport = React.lazy(
  () =>
    import(
      "../Containers/Resident/ResidentSettings/CareRounds/CareRoundReport"
    ),
);
const ResidentAiAlerts = React.lazy(
  () => import("../Containers/Resident/ResidentAlerts"),
);
const ResidentIncidentRegister = React.lazy(
  () => import("../Containers/Resident/IncidentRegister"),
);
const ResidentSafeguardingRegister = React.lazy(
  () => import("../Components/Resident/SafeguardingRegister"),
);
const ResidentWoundReport = React.lazy(
  () => import("../Containers/Resident/WoundReport"),
);
const ResidentBowelGrid = React.lazy(
  () => import("../Containers/Resident/BowelGrid"),
);
const ResidentScheduledReport = React.lazy(
  () => import("../Containers/Resident/ScheduledReport"),
);
const ResidentScheduleTracker = React.lazy(
  () => import("../Containers/Resident/ScheduleTracker"),
);
const ResidentCarePlanAudit = React.lazy(
  () => import("../Containers/Resident/CarePlanAudit"),
);

const ResidentRoutes = ({ itemValidator }) => {
  return (
    <>
      <Route
        exact
        path="/d/resident"
        render={() => itemValidator(<Resident />, `RESIDENT`, `DISPLAY`)}
      />
      {/* ONE non-exact route for every resident edit tab (incl. legacy
          upload-documents/basic-information slugs). Per-slug exact routes
          remounted the whole shell — top bar + status strip flashed and the
          layout shifted on every tab change. The inner Switch in
          ResidentEditTabs owns slug routing; unknown slugs redirect to the
          first tab. */}
      <Route
        path="/d/resident/edit/:id"
        render={() =>
          itemValidator(<ResidentEditTabs />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/resident/add"
        render={() => itemValidator(<ResidentAdd />, `RESIDENT`, `DISPLAY`)}
      />
      <Route
        exact
        path="/d/resident/pre-assessment-list"
        render={() =>
          itemValidator(<ResidentPreAssessment />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/resident/ai-alerts"
        render={() =>
          itemValidator(<ResidentAiAlerts />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/resident/incidents"
        render={() =>
          itemValidator(<ResidentIncidentRegister />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/resident/safeguarding"
        render={() =>
          itemValidator(<ResidentSafeguardingRegister />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/resident/wound-report"
        render={() =>
          itemValidator(<ResidentWoundReport />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/resident/bowel-grid"
        render={() =>
          itemValidator(<ResidentBowelGrid />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/resident/scheduled-report"
        render={() =>
          itemValidator(<ResidentScheduledReport />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/resident/schedule-tracker"
        render={() =>
          itemValidator(<ResidentScheduleTracker />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/resident/care-plan-audit"
        render={() =>
          itemValidator(<ResidentCarePlanAudit />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/resident/care-round-types"
        render={() =>
          itemValidator(<ResidentCareRoundTypes />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/resident/care-rounds/edit/:id"
        render={() =>
          itemValidator(<ResidentCareRoundEdit />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/resident/care-rounds/calendar"
        render={() =>
          itemValidator(<CareRoundsCalendarPage />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path={[
          "/d/resident/care-rounds/report",
          "/d/resident/care-rounds/report/daily",
          "/d/resident/care-rounds/report/twice-daily",
          "/d/resident/care-rounds/report/weekly",
          "/d/resident/care-rounds/report/hourly",
        ]}
        render={() =>
          itemValidator(<CareRoundsReportPage />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/resident/care-rounds/daily-report"
        render={() => <Redirect to="/d/resident/care-rounds/report/daily" />}
      />
      <Route
        exact
        path="/d/resident/care-rounds/twice-daily-report"
        render={() => (
          <Redirect to="/d/resident/care-rounds/report/twice-daily" />
        )}
      />
      <Route
        exact
        path="/d/resident/care-rounds/weekly-report"
        render={() => <Redirect to="/d/resident/care-rounds/report/weekly" />}
      />
      <Route
        exact
        path="/d/resident/care-rounds/hourly-report"
        render={() => <Redirect to="/d/resident/care-rounds/report/hourly" />}
      />
      <Route
        exact
        path="/d/resident/care-rounds/list"
        render={() => <Redirect to="/d/resident/care-rounds" />}
      />
      <Route
        exact
        path="/d/resident/care-rounds"
        render={() => itemValidator(<CareRoundsPage />, `RESIDENT`, `DISPLAY`)}
      />
      <Route
        exact
        path="/d/resident/care-rounds/report/:id([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})"
        render={() =>
          itemValidator(<ResidentCareRoundReport />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/r/settings/care-round-types"
        render={() => <Redirect to="/d/resident/care-round-types" />}
      />
      <Route
        exact
        path="/d/r/settings/care-rounds/daily-report"
        render={() => <Redirect to="/d/resident/care-rounds/report/daily" />}
      />
      <Route
        exact
        path="/d/r/settings/care-rounds/twice-daily-report"
        render={() => (
          <Redirect to="/d/resident/care-rounds/report/twice-daily" />
        )}
      />
      <Route
        exact
        path="/d/r/settings/care-rounds/weekly-report"
        render={() => <Redirect to="/d/resident/care-rounds/report/weekly" />}
      />
      <Route
        exact
        path="/d/r/settings/care-rounds/hourly-report"
        render={() => <Redirect to="/d/resident/care-rounds/report/hourly" />}
      />
      <Route
        exact
        path="/d/r/settings/care-rounds/list"
        render={() => <Redirect to="/d/resident/care-rounds" />}
      />
      <Route
        exact
        path="/d/r/settings/care-rounds/edit/:id"
        render={({ match }) => (
          <Redirect to={`/d/resident/care-rounds/edit/${match.params.id}`} />
        )}
      />
      <Route
        exact
        path="/d/r/settings/care-rounds/calendar"
        render={() => <Redirect to="/d/resident/care-rounds/calendar" />}
      />
      <Route
        exact
        path={[
          "/d/r/settings/care-rounds/report",
          "/d/r/settings/care-rounds/report/daily",
          "/d/r/settings/care-rounds/report/twice-daily",
          "/d/r/settings/care-rounds/report/weekly",
          "/d/r/settings/care-rounds/report/hourly",
        ]}
        render={({ location }) => (
          <Redirect
            to={location.pathname.replace(
              "/d/r/settings/care-rounds",
              "/d/resident/care-rounds",
            )}
          />
        )}
      />
      <Route
        exact
        path="/d/r/settings/care-rounds/report/:id([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})"
        render={({ match }) => (
          <Redirect to={`/d/resident/care-rounds/report/${match.params.id}`} />
        )}
      />
      <Route
        exact
        path="/d/r/settings/care-rounds"
        render={() => <Redirect to="/d/resident/care-rounds" />}
      />

      <Route
        exact
        path="/d/r/settings/medical-condition"
        render={() =>
          itemValidator(
            <ResidentSettingsTabs />,
            `RESIDENT-SETTINGS`,
            `DISPLAY`,
          )
        }
      />
      <Route
        exact
        path="/d/resident/pre-assessment/add"
        render={() => itemValidator(<PreAssessmentAdd />, `RESIDENT`, `WRITE`)}
      />
      <Route
        exact
        path="/d/resident/pre-assessment/edit/:id"
        render={() =>
          itemValidator(
            <PreAssessmentAdd isEditing={true} />,
            `RESIDENT`,
            `WRITE`,
          )
        }
      />
      <Route
        exact
        path="/d/r/settings/generic"
        render={() =>
          itemValidator(
            <ResidentSettingsTabs />,
            `RESIDENT-SETTINGS`,
            `DISPLAY`,
          )
        }
      />
      <Route
        exact
        path="/d/r/settings/devices"
        render={() =>
          itemValidator(
            <ResidentSettingsTabs />,
            `RESIDENT-SETTINGS`,
            `DISPLAY`,
          )
        }
      />

      {/* /d/r/settings/assessments now lands on the Needs tab as default
          (Screening tab retired). /assessments/needs URL removed. */}
      <Route
        exact
        path="/d/r/settings/assessments"
        render={() =>
          itemValidator(
            <ResidentAssessmentsTabs />,
            `RESIDENT-SETTINGS`,
            `DISPLAY`,
          )
        }
      />
      <Route
        exact
        path="/d/r/settings/assessments/risk"
        render={() =>
          itemValidator(
            <ResidentAssessmentsTabs />,
            `RESIDENT-SETTINGS`,
            `DISPLAY`,
          )
        }
      />
      <Route
        exact
        path="/d/r/settings/care-plan/medical-condition"
        render={() =>
          itemValidator(
            <ResidentCarePlanTabs />,
            `RESIDENT-SETTINGS`,
            `DISPLAY`,
          )
        }
      />
      <Route
        exact
        path="/d/r/settings/assessments/capacity"
        render={() =>
          itemValidator(
            <ResidentAssessmentsTabs />,
            `RESIDENT-SETTINGS`,
            `DISPLAY`,
          )
        }
      />
      <Route
        exact
        path="/d/r/settings/assessments/tool"
        render={() =>
          itemValidator(
            <ResidentAssessmentsTabs />,
            `RESIDENT-SETTINGS`,
            `DISPLAY`,
          )
        }
      />
      {/* Post-AGNI liberty decision templates (458) — its own tab beside DoLS. */}
      <Route
        exact
        path="/d/r/settings/assessments/liberty"
        render={() =>
          itemValidator(
            <ResidentAssessmentsTabs />,
            `RESIDENT-SETTINGS`,
            `DISPLAY`,
          )
        }
      />
      <Route
        exact
        path="/d/r/settings/assessments/dols"
        render={() =>
          itemValidator(
            <ResidentAssessmentsTabs />,
            `RESIDENT-SETTINGS`,
            `DISPLAY`,
          )
        }
      />
      <Route
        exact
        path="/d/r/settings/care-plan"
        render={() =>
          itemValidator(
            <ResidentCarePlanTabs />,
            `RESIDENT-SETTINGS`,
            `DISPLAY`,
          )
        }
      />
      <Route
        exact
        path="/d/r/settings/care-plan/acute-conditions"
        render={() =>
          itemValidator(
            <ResidentCarePlanTabs />,
            `RESIDENT-SETTINGS`,
            `DISPLAY`,
          )
        }
      />
      <Route
        exact
        path="/d/r/settings/care-team"
        render={() =>
          itemValidator(
            <ResidentCarePlanTeam />,
            `RESIDENT-SETTINGS`,
            `DISPLAY`,
          )
        }
      />
      <Route
        exact
        path="/d/r/settings/resident-groups"
        render={() =>
          itemValidator(<ResidentGroups />, `RESIDENT-SETTINGS`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/r/settings/compliance"
        render={() =>
          itemValidator(
            <ResidentComplianceTabs />,
            `RESIDENT-SETTINGS`,
            `DISPLAY`,
          )
        }
      />
      <Route
        exact
        path="/d/r/settings/compliance/consent"
        render={() =>
          itemValidator(
            <ResidentComplianceTabs />,
            `RESIDENT-SETTINGS`,
            `DISPLAY`,
          )
        }
      />
      <Route
        exact
        path="/d/r/settings/compliance/governance"
        render={() =>
          itemValidator(
            <ResidentComplianceTabs />,
            `RESIDENT-SETTINGS`,
            `DISPLAY`,
          )
        }
      />
      <Route
        exact
        path="/d/r/settings/insights"
        render={() =>
          itemValidator(
            <ResidentInsightsToolsTabs />,
            `RESIDENT-SETTINGS`,
            `DISPLAY`,
          )
        }
      />
      <Route
        exact
        path="/d/r/settings/insights/charts"
        render={() => <Redirect to="/d/r/settings/insights" />}
      />
      <Route
        exact
        path="/d/r/settings/location-rules"
        render={() =>
          itemValidator(
            <ResidentLocationRulesTabs />,
            `RESIDENT-SETTINGS`,
            `DISPLAY`,
          )
        }
      />
      <Route
        exact
        path="/d/r/settings/location-rules/journey"
        render={() =>
          itemValidator(
            <ResidentLocationRulesTabs />,
            `RESIDENT-SETTINGS`,
            `DISPLAY`,
          )
        }
      />
    </>
  );
};

export default ResidentRoutes;
